import { useTranslation } from 'react-i18next'
import { Breadcrumbs, Crumb } from '@carsys/ui'
import { ConceptAppPath, ConceptAppRequestMatchURL } from 'app/ConceptApp/routes'
import React from 'react'

export const ConceptAppBreadCrumbs: React.FC = ({ ...props }: React.ComponentProps<typeof Breadcrumbs>) => {
  const { t } = useTranslation()

  const requestID = localStorage.getItem('requestID')

  return (
    <Breadcrumbs {...props}>
      <Crumb data-testid='crumb-conceptapp' key='crumb-conceptapp' path={ConceptAppPath} text={t('Concept_app.title')} />
      <Crumb
        data-testid='crumb-conceptapp-request'
        key='crumb-conceptapp-request'
        path={ConceptAppRequestMatchURL}
        text={requestID as string}
      />
    </Breadcrumbs>
  )
}

export default ConceptAppBreadCrumbs
